<template>
  <div class="date-selection-row" :class="customClass">
    <button
      type="button"
      class="btn-date-today"
      :class="{ 'is-current': selectedDate === currentDate }"
      @click="goToToday"
    >
      Today
    </button>
    <div class="date-selection-container">
      <slick ref="slick1" :options="dateSelectionSlider">
        <div v-for="(dateLoop, loop) in dates" :key="loop">
          <div
            v-on:click="onChangeTab(dateLoop)"
            :class="[
              'date-slider-box',
              selectedDate == dateLoop
                ? 'active cursor-pointer'
                : allowPastBooking == 'Y'
                ? 'cursor-pointer'
                : new Date(currentDate) > new Date(dateLoop)
                ? 'cursor-pointer'
                : 'cursor-pointer',
              selectedDate == dateLoop && selectedDate != currentDate
                ? 'date-not-today-blink'
                : '',
            ]"
          >
            <div class="text-center">
              <span>{{ dateLoop }}</span>
              <div class="lh-1" style="font-size:80%">
                {{ dateLoop | dayparse }}
              </div>
            </div>
          </div>
        </div>
      </slick>
    </div>
  </div>
</template>

<script>
  import Slick from "vue-slick";
  import moment from "moment";
  import { EventBus } from "@/main";

  export default {
    props: {
      childComponents: {
        type: Object,
      },
      customClass: {
        type: String,
        default: "",
      },
      dateSelectionSlider: {
        type: Object,
        default: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 1,
        },
      },
      onChangeTab: {
        type: Function,
      },

      selectedTabIndex: {
        type: Number,
        default: 0,
      },
    },
    components: {
      Slick,
    },
    data() {
      return {
        currentDate: "",
        cinema_id: "",
      };
    },
    beforeMount() {},
    mounted() {
      this.currentDate = moment().format("DD-MM-YYYY");
    },
    watch: {
      selectedTabIndex(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(2, true);
          });
        }
      },
    },
    computed: {
      dates() {
        if (this.$refs && this.$refs.slick1) {
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(2, true);
          });
        }
        return this.childComponents.getDatesArray;
      },
      allowPastBooking() {
        return "N";
      },
      selectedDate() {
        if (this.childComponents.isSlideSlick) {
          let getDateIndex = this.childComponents.getDatesArray.findIndex(
            (dateIndex) => {
              return dateIndex == this.childComponents.SELECTED_DATE;
            }
          );
          this.$refs.slick1.goTo(getDateIndex, true);
        }
        this.childComponents.isSlideSlick = false;
        return this.childComponents.SELECTED_DATE;
      },
    },
    methods: {
      goToToday() {
        if (!this.currentDate) {
          this.currentDate = moment().format("DD-MM-YYYY");
        }
        if (this.selectedDate === this.currentDate) {
          return;
        }
        this.childComponents.isSlideSlick = true;
        if (typeof this.onChangeTab === "function") {
          this.onChangeTab(this.currentDate);
        }
      },
    },
  };
</script>

<style>
  .pointer-none {
    cursor: no-drop;
    pointer-events: none;
  }

  .width97 {
    width: 95% !important;
  }

  .date-selection-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
  }

  .date-selection-row .date-selection-container {
    flex: 1;
    min-width: 0;
    margin-bottom: 0;
    width: auto;
  }

  .btn-date-today {
    flex-shrink: 0;
    height: 40px;
    padding: 0 14px;
    border: 1px solid var(--blue);
    background: #fff;
    color: var(--blue);
    border-radius: var(--posGlobalRadius);
    font-weight: 600;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s, color 0.2s;
  }

  .btn-date-today:hover {
    background: var(--blue);
    color: #fff;
  }

  .btn-date-today.is-current {
    background: var(--blue);
    color: #fff;
  }

  .date-slider-box.date-not-today-blink {
    animation: date-not-today-blink 1s ease-in-out infinite;
    background-color: rgba(255, 152, 0, 0.18);
    border-bottom-color: #ff9800;
    color: #e65100;
  }

  @keyframes date-not-today-blink {
    0%,
    100% {
      opacity: 1;
      background-color: rgba(255, 152, 0, 0.28);
      box-shadow: inset 0 0 0 1px rgba(255, 152, 0, 0.45);
    }
    50% {
      opacity: 0.55;
      background-color: rgba(255, 152, 0, 0.08);
      box-shadow: inset 0 0 0 1px transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/posDateSlider.vue